import { useApiClient, RequestConfig } from "@/hooks";
import { useMemo } from "react";

export function useSignInApi(login: string, senha: string, empresaId: number) {
  const config = useMemo<RequestConfig>(() => ({
    url: "/auth/sign-in",
    method: "POST",
    data: { login, senha, empresaId },
  }), [login, senha, empresaId]);

  return useApiClient(config);
}


